import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import FormSidebar from 'components/formSidebar';
import noFormSvg from '../../assets/no-form.svg';

const NoForm = ({ type }) => {
  const [searchParams] = useSearchParams();

  const decodeUTF8 = (str) => {
    return decodeURIComponent(escape(window.atob(str)));
  };

  const auction = decodeUTF8(searchParams.get('title'));

  return (
    <div className="bg-white">
      <Container className="py-60">
        <Row className="ml-md-5">
          <Col md={8} className="ml-md-3 order-2 order-md-1">
            <h2 className="mb-4 text-center text-tangaroa">¡Ya tenemos tus datos!</h2>
            <p className="text-center text-tangaroa">
              Anteriormente proporcionaste los datos necesarios.
              Pronto nos pondremos en contacto contigo para hacer entrega de tu premio.
            </p>
            <div className="text-center">
              <img alt="Ya tenemos tus datos" src={noFormSvg} />
            </div>
            <p className="text-center text-tangaroa f-600">Haz clic en el botón de “Salir” para continuar navegando en el sitio.</p>
            <div className="text-center">
              <a type="button" href="/" className="btn btn-primary btn-size-override mb-15">Salir</a>
            </div>

          </Col>
          <Col md={3} className="order-1 order-md-2 mb-1 mb-md-0">
            <FormSidebar auction={auction} type={type} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

NoForm.propTypes = {
  type: PropTypes.string.isRequired,
};

export default NoForm;
